module.exports = __webpack_public_path__ + "img/3-en.074fb246.jpg";